import * as React from "react";
import { forwardRef } from "react";
const SvgLogOut = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 25 24", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M5.00342 21C4.60342 21 4.25342 20.85 3.95342 20.55C3.65342 20.25 3.50342 19.9 3.50342 19.5V4.5C3.50342 4.1 3.65342 3.75 3.95342 3.45C4.25342 3.15 4.60342 3 5.00342 3H12.2784V4.5H5.00342V19.5H12.2784V21H5.00342ZM17.1534 16.375L16.0784 15.3L18.6284 12.75H9.87842V11.25H18.5784L16.0284 8.7L17.1034 7.625L21.5034 12.025L17.1534 16.375Z" }));
const ForwardRef = forwardRef(SvgLogOut);
export { ForwardRef as ReactComponent };
